import React, { Component } from "react";

import { Button, Card, CardContent, CardHeader } from "@mui/material";

import ItemDetailComponent from "./ItemDetailComponent";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Environment from "../../utils/Environement";

interface PropsInterface {
  restaurant: PopinaRestaurant;
}

interface StateInterface {
  open: boolean;
}

class CategoryTableComponent extends Component {
  public props: PropsInterface;
  public state: StateInterface;
  private modalElement: React.RefObject<ItemDetailComponent>;

  constructor(props: PropsInterface) {
    super(props);
    this.state = {
      open: false,
    };
    this.props = props;
    this.modalElement = React.createRef();
  }

  private handleOpen = (item: any) => {
    this.modalElement.current?.handleModal(item);

    this.setState({
      open: true,
    });
  };

  render() {
    return (
      <div style={{ width: "80%", margin: "auto", padding: "0" }}>
        {this.props.restaurant.category.map((aCategory, index) => (
          <Card
            style={{
              margin: "30px 0",
              backgroundColor: "#F1F1F5",
            }}
            key={aCategory.client_id}
          >
            <CardHeader
              title={`Catégorie : ${aCategory.name}`}
              disableTypography
              style={{
                backgroundColor: "#474F5E",
                color: "white",
                fontSize: "20px",
              }}
            />
            <CardContent>
              {this.props.restaurant
                .getAllItemForCategory(aCategory.client_id)
                .map((item, i) => (
                  <div
                    key={i}
                    style={{
                      border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
                      borderRadius: "3px",
                      backgroundColor: "white",
                      display: "flex",
                      margin: "5px",
                      padding: "5px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "17px",
                        color: "#474F5E",
                        alignItems: "center",
                        display: "flex",
                        paddingLeft: "20px",
                        visibility: "visible",
                        width: "30%",
                      }}
                    >
                      {item.name}
                    </div>
                    <Button
                      onClick={() => this.handleOpen(item)}
                      variant="contained"
                      color="secondary"
                      size="small"
                      style={{
                        color: "white",
                        textTransform: "capitalize",
                        padding: "9px 20px",
                        fontWeight: "bold",
                      }}
                    >
                      Détail
                    </Button>
                  </div>
                ))}
              <div>
                <ItemDetailComponent
                  restaurant={this.props.restaurant}
                  ref={this.modalElement}
                />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }
}

export default CategoryTableComponent;
